import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialog: {
    '& .MuiDialog-paper': {
      width: '90%',
      maxWidth: '90%',
      height: '780px'
    },
    '& .MuiInputBase-root': {
      marginY: 0,
      paddingY: 0
    }
  },
  reportOptionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    width: '100%'
  },
  chip: {
    right: 0
  },
  viewButton: {
    minWidth: '150px',
    minHeight: '38px'
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '45%',
    alignItems: 'flex-start',
    gap: '16px',
    '@media (max-width: 1024px)': {
      width: '100%'
    }
  },
  saveViewRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'flex-end',
    gap: '8px'
  },
  formControl: {
    width: '100%'
  },
  autocomplete: {
    minWidth: '200px'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '32px',
    width: '100%',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      gap: '16px'
    }
  },
  title: {
    width: '100%',

    '& .MuiOutlinedInput-root': {
      paddingTop: 0,
      paddingBottom: 0
    }
  },

  textFieldReset: {
    '& .MuiOutlinedInput-root': {
      margin: 0,
      padding: 0,
      width: '100%',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        paddingRight: '8px',
        paddingLeft: '8px',
        height: '87px !important'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        paddingRight: '8px',
        paddingLeft: '8px',
        height: '87px !important'
      }
    },
    '& .MuiInputBase-input': {
      paddingTop: 0,
      paddingBottom: 0,
      height: '88px !important',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        paddingRight: '8px',
        paddingLeft: '8px'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        paddingRight: '8px',
        paddingLeft: '8px',
        height: '88px !important'
      }
    }
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px'
  },
  label: {
    marginBottom: '8px'
  },
  copyToClipboardText: {
    marginTop: '8px',
    color: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium,
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  previewColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'flex-end',
    '@media (max-width: 1024px)': {
      alignItems: 'stretch'
    }
  },
  previewFieldset: {
    minWidth: 0,
    width: '100%'
  },
  switchLabel: {
    marginLeft: '16px'
  },
  message: {
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    textAlign: 'left',
    marginTop: '8px'
  },
  noVisualizationMessage: {
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    textAlign: 'left',
    marginTop: '8px',
    marginBottom: '8px'
  },
  loadingPosition: {
    marginTop: '32px',
    // center the loading position
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    paddingLeft: '8px',
    paddingRight: '8px',
    width: '45rem'
  },
  noReportSelectedMessage: {
    // add a border around the preview
    border: `1px solid ${capitalDesignTokens.semanticColors.border.primary}`,
    borderRadius: '4px',
    paddingX: '16px',
    paddingY: '24px',
    marginTop: 0
  },
  preview: {
    marginTop: '16px'
  },
  errorFailedEmbed: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    color: capitalDesignTokens.semanticColors.foreground.errorSmall
  },
  errorIcon: {
    paddingTop: '8px',
    fill: capitalDesignTokens.semanticColors.foreground.errorSmall,
    marginRight: '8px'
  },
  visualizationSelectIcon: {
    marginRight: '8px'
  },
  visualizationSelectedValue: {
    color: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium
  },
  switchInputProps: {
    style: { display: 'none' }
  },

  titleProps: {
    maxLength: 60
  },
  radioButtonProps: {
    style: { display: 'none' }
  },
  progress: {
    marginLeft: '4px'
  },
  switch: {
    marginRight: 0
  },
  copyEmbedSnippetButton: {
    color: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium,
    fontColor: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium,
    padding: '0px 4px'
  }
});
